<script setup>
import { reactive, ref } from 'vue'
import { useDisplay } from 'vuetify'

const { width, height } = useDisplay()
const staticURLImg = useRuntimeConfig().public.staticURLImg
const imgWidth = ref(0)

const props = defineProps({
    data: {
        type: Array,
        default: null,
    },
})

defineExpose({ open })

const lightBox = reactive({
    show: false,
    slide: 0,
    selection: null,
})

onMounted(() => {
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            lightBox.selection = null
        }
    })
})

const calcWidth = computed(() => {
    let img = new Image()
    img.src = staticURLImg + props.data[lightBox.slide].source
    img.onload = function () {
        if (img.naturalWidth > width.value) {
            imgWidth.value = width.value * 0.95
        } else {
            imgWidth.value = img.naturalWidth * 0.98
        }
    }
})

function open(clickedItem) {
    lightBox.slide = clickedItem
    lightBox.show = true
}

function next() {
    lightBox.slide = lightBox.slide + 1 === props.data.length ? 0 : lightBox.slide + 1
}

function prev() {
    lightBox.slide = lightBox.slide - 1 < 0 ? props.data.length - 1 : lightBox.slide - 1
}
</script>

<template>
    <v-dialog id="lightbox" v-model="lightBox.show" fullscreen transition="dialog-top-transition">
        <v-card>
            <v-toolbar>
                <!-- <v-toolbar-title> {{ data[lightBox.slide].alt }} </v-toolbar-title> -->
                <v-spacer></v-spacer>
                {{ lightBox.slide + 1 }} of {{ data.length }}
                <v-btn icon :disabled="data.length == 1" @click.stop="prev" aria-label="Go to previous">
                    <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn icon :disabled="data.length == 1" @click.stop="next" aria-label="Go to next">
                    <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
                <v-btn icon @click.stop="lightBox.show = false" aria-label="Close gallery">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-container class="d-flex align-start justify-center">
                <v-row class="">
                    <v-col cols="12" class="text-h6 text-center">{{ data[lightBox.slide].alt }}</v-col>
                    <v-col class="pt-0">
                        <v-img
                            id="slide"
                            :width="imgWidth"
                            class="mx-auto rounded elevation-1"
                            :src="staticURLImg + data[lightBox.slide].source"
                            :alt="data[lightBox.slide].alt"
                        >
                            {{ calcWidth }}
                        </v-img>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<style scoped></style>
